module.exports = __webpack_public_path__ + "static/media/400091_02.adf64900.png";